import { Controller, useForm, useFormContext } from "react-hook-form";
import MinusButton from "../../../../components/MinusButton";
import SelectHookFormSingle from "../../../../components/SelectHookFormSingle";
import { toast } from "../../../../components/toastNotification";

const OfficeImageSectionAddForm = () => {
  const formMethods = useFormContext();
  const { control, handleSubmit, watch, setValue } = useForm();
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 mx-4 pb-2 lg:lg:gap-12 gap-2  gap-2">
      <div>
        <div className="flex flex-row items-center gap-2">
          <Controller
            name="imageCategoryId"
            control={formMethods.control}
            rules={{ required: false }}
            render={({ field }) => (
              <SelectHookFormSingle
                label={"Image Category"}
                field={field}
                onChange={(e) => {
                  field.onChange(e ? e.value : null);
                }}
                value={field.value ? field.value : null}
                options={undefined}
                isLoading={false}
                required={false}
                secondDiv={"grid grid-cols-1"}
                isDisabled={true}
              />
            )}
          />
          <Controller
            name="imageLabelId"
            control={formMethods.control}
            rules={{ required: false }}
            render={({ field }) => (
              <SelectHookFormSingle
                label={"Image Label"}
                field={field}
                onChange={(e) => {
                  field.onChange(e ? e.value : null);
                }}
                value={field.value ? field.value : null}
                options={undefined}
                isLoading={false}
                required={false}
                secondDiv={"grid grid-cols-1"}
                isDisabled={true}
              />
            )}
          />
        </div>
      </div>
      <div className="space-y-1">
        <label className="text-xs">
          <b className="text-italic text-red-500 ">Note:</b> Kindly choose an
          image to upload
        </label>
        <div className="text-xs">
          <div className=""></div>
          <div className="flex justify-center py-2">
            <label
              className={
                "opacity-50 text-center bg-primary text-white py-1 px-3 border font-medium rounded-full transition duration-500"
              }
            >
              <input
                type="file"
                accept="image/*"
                className="hidden"
                disabled={true}
              />
              Choose Image
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OfficeImageSectionAddForm;
